import React, { useCallback } from 'react';
import { Tooltip, IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import ChatIcon from '@mui/icons-material/Chat';

import CONFIG from '@/config';
import AuthUserStore from '../common/utils/AuthUser';

const useStyles: any = makeStyles((theme: any) => ({
  technicalInfrastructureWrapper: {
    position: 'relative',
    marginTop: theme.spacing(3)
  },
  speedDial: {
    width: '20px',
    height: '20px',
    zIndex: 9999,
    color: '#ffffff',
    position: 'fixed',
    right: theme.spacing(1),
    bottom: theme.spacing(2),
    backgroundColor: '#055577',
    border: '1px solid #055577',
    '&:hover': {
      color: 'black',
      backgroundColor: '#ffffff'
    }
  },
  icon: {
    fontSize: 18
  },
  linksSection: {
    padding: 10,
    '& a': {
      width: '100%',
      padding: '5px 10px 0px 10px',
      textDecoration: 'none',
      display: 'inline-block'
    }
  },
  divider: {
    margin: theme.spacing(1, 0)
  },
  switchNetwork: {
    justifyContent: 'space-between',
    '& .MuiFormControlLabel-labelPlacementStart': {
      margin: 0,
      width: '100%',
      display: 'flex',
      padding: '0 10px',
      justifyContent: 'space-between'
    }
  }
}));

function ChatBot() {
  const classes = useStyles();
  const jwtToken = AuthUserStore.getAuthToken();

  const handleClick = useCallback(() => {
    const chatDomain = CONFIG.CHATBOT_URL;
    const powDomain = window.location.origin;

    let childWindow = null;
    let channel = null;
    let initTimeoutId = null;

    try {
      childWindow = window.open(
        `${chatDomain}/chatbot/playground`,
        'Chat',
        'width=800,height=600'
      );

      if (!childWindow) {
        throw new Error(
          'Failed to open chatbot window - popup might be blocked'
        );
      }

      // Create a new message channel
      channel = new MessageChannel();

      // Set timeout for initialization
      initTimeoutId = setTimeout(() => {
        console.error('Connection timeout - chatbot window did not respond');
        if (channel) {
          channel.port1.close();
          channel.port2.close();
        }
      }, 10000);

      // Wait for the chatbot window to respond
      setTimeout(() => {
        // Send the message port to the chatbot window
        childWindow.postMessage('init', chatDomain, [channel.port2]);
        console.log('Sent init to chatbot window');

        // Listen for the response from the chatbot window
        channel.port1.onmessage = event => {
          console.log('Received message from chatbot window:', event.data);

          if (event.data.type === 'ready') {
            // Clear timeout for initialization
            if (initTimeoutId) {
              clearTimeout(initTimeoutId);
            }

            // Send the token to the chatbot window
            channel.port1.postMessage({
              type: 'token',
              token: jwtToken,
              secretIdentifier: powDomain
            });
            console.log('Sent token to chatbot window');
          }
        };
      }, 1000);

      // Handle chatbot window close event
      const checkChildWindow = setInterval(() => {
        if (childWindow.closed) {
          clearInterval(checkChildWindow);
          if (channel) {
            channel.port1.close();
            channel.port2.close();
          }
        }
      }, 1000);
    } catch (error) {
      console.error('Failed to open chatbot window:', error);
      if (channel) {
        channel.port1.close();
        channel.port2.close();
      }
      if (initTimeoutId) {
        clearTimeout(initTimeoutId);
      }
    }
  }, [jwtToken]);

  return (
    <div className={classes.technicalInfrastructureWrapper}>
      <Tooltip arrow title="AI Chatbot" placement="left">
        <IconButton
          onClick={handleClick}
          className={classes.speedDial}
          size="large"
        >
          <ChatIcon className={classes.icon} />
        </IconButton>
      </Tooltip>
    </div>
  );
}

export default ChatBot;
